import { render } from "./books.vue?vue&type=template&id=7a62a90f"
import script from "./books.vue?vue&type=script&lang=js"
export * from "./books.vue?vue&type=script&lang=js"
script.render = render

export default script